import humps from 'lodash-humps';

const state = {
    resources: {},
};

const getters = {
    getResource: state => id => { return state.resources[id] || null; },
};

const mutations = {
};

const actions = {
    async getOnePrest({ commit, rootGetters }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        const { resourceId, placeId, serviceId } = payload;
        const response = await this._vm.$api.resources.getOnePrest(establishmentId, placeId, resourceId, serviceId);

        return humps(response.data);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
